import PropTypes from 'prop-types';
import {Translate, I18n} from 'react-redux-i18n';
import {EntityIllustration, Icon, OperaStatus} from 'front-onceforall-core';
import {isEmpty} from 'front-onceforall-core/dist/utils/strings';
import {ACTRADIS_MASTER_PLATFORM} from '../../../utils/constant';
import {getOrganisationLogoUrl} from '../../../utils/organisation';
import authenticationService from '../../../services/authentication/AuthenticationService';
import InvitationSettings from './invitationSettings';
import MessageInfo from '../../messageInfo';

function DetailsView(props) {
  const isManager = authenticationService.roles().isManager();
  const {organisation} = props;

  const getIdentificationNumbersFields = () => Object.keys(props.organisation.identificationNumbers).map((code, index) => (
    <div key={`id-number-${index}`}>
      <hr className="my-4"/>
      <h3><Translate value={`identificationNumber.${props.organisation.country}.${code}.name`}/></h3>
      <div>{props.organisation.identificationNumbers[code]}</div>
    </div>
  ));

  return (
    <div className="row">
      <div
        className="col-xl-7"
        style={{marginBottom: 35}}
      >
        <h2>
          <Translate value={'organisationSetting.detailsTitle'}/>
        </h2>
        <div className="card">
          <MessageInfo message="organisationSetting.cantEditMessage"/>
          <div className="row mb-4">
            <div className="col-12 inline-container space-between">
              <div className="inline-container">
                <div
                  onMouseEnter={props.onShowUploadButton}
                  onMouseLeave={props.onShowUploadButton}
                  style={{position: 'relative'}}
                >
                  <EntityIllustration
                    country={organisation.country}
                    name={organisation.fullName}
                    imageUrl={getOrganisationLogoUrl(organisation.organisationId)}
                  />
                  {isManager && props.showLogoUploadButton &&
                    <button
                      type="button"
                      className="small primary"
                      style={{
                        background: 'rgba(0, 0, 0, 0.7)',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        height: 37,
                        width: 55
                      }}
                      onClick={props.onSwitchUploadLogoModal}
                      tooltip={I18n.t('organisationSetting.uploadLogo')}
                      flow="right"
                    >
                      <Icon
                        icon="upload"
                        size={18}
                      />
                    </button>
                  }
                </div>
                <div className="ml-3">
                  <div className="font-size-l">
                    <strong>{organisation.fullName}</strong>
                  </div>
                  <div data-id="registrationNumber">{organisation.registrationNumber}</div>
                </div>
              </div>
              <OperaStatus
                organisation={organisation}
                masterPlatformToShow={ACTRADIS_MASTER_PLATFORM}
              />
            </div>
          </div>
          <hr className="my-4"/>
          <h3><Translate value="organisation.businessLine.title"/></h3>
          <div><Translate value={`organisation.businessLine.${props.organisation.businessLine}`}/></div>
          <hr className="my-4"/>
          <h3><Translate value="address.addressLine"/></h3>
          <div>{props.organisation.address.addressLine}</div>
          <div>{props.organisation.address.postCode} {props.organisation.address.city}</div>
          {getIdentificationNumbersFields()}
          {!isEmpty(organisation.website) &&
            <>
              <hr className="my-4"/>
              <h3><Translate value="organisation.website"/></h3>
              <div className="flex-container active font-size-s">
                <Icon
                  icon="new-tab"
                  size={16}
                />
                <a
                  href={organisation.website}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {organisation.website}
                </a>
              </div>
            </>
          }
        </div>
      </div>
      <div className="col-xl-5">
        <InvitationSettings/>
      </div>
    </div>
  );
}

DetailsView.propTypes = {
  organisation: PropTypes.object.isRequired,
  showLogoUploadButton: PropTypes.bool.isRequired,
  onShowUploadButton: PropTypes.func.isRequired,
  onSwitchUploadLogoModal: PropTypes.func.isRequired
};

export default DetailsView;
